<template>
    <div v-if="data.length == 0">
        <i>{{ $trans('web_search.profile_card.no_content') }}</i>
    </div>
    <template v-else>
        <template v-for="(record, index) in data" :key="index">
            <a class="record" :href="record.url" target="_blank">
                <div class="title">{{ record.title }}</div>
                <img src="/media/images/web_search/drupal_reference_icon.png">
            </a>
        </template>
    </template>
</template>

<script>
import { TopRight as TopRightIcon } from '@element-plus/icons-vue'

export default {
    components: {
        TopRightIcon,
    },
    props: {
        data: {
            type: Array,
            required: false,
            default: [],
        },
    },
}
</script>

<style scoped>
.record {
    color: #191919;
    font-size: 16px;
    line-height: 18px;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.record img {
    position: relative;
    height: 25px;
    width: 25px;
}

.record:not(:last-child) {
    padding-bottom: 8px;
    border-bottom: 1px solid #3C3C3C;
    margin-bottom: 8px;
}

.record .title {
    flex-grow: 1;
}
</style>
